import { Component, importProvidersFrom, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { NgxsModule, Store } from '@ngxs/store';
import { TaskState } from '@tasks/state/state';
import { TaskShellComponent } from '@tasks/task-shell/task-shell.component';
import { TasksSplashComponent } from '@tasks/tasks-splash/tasks-splash.component';
import { ProjectDataResolver } from 'app/modules/projects/projects.resolvers';
import { TaskActions } from './state/actions';

export const routes: Routes = [
  {
    path: ':taskRelatedTo/:taskRelatedToId',
    component: TasksSplashComponent,
    providers: [importProvidersFrom(NgxsModule.forFeature([TaskState]))],
    resolve: {
      options: ProjectDataResolver,
    },
    canDeactivate: [
      (component: Component, activatedRouteSnapshot: ActivatedRouteSnapshot): boolean => {
        inject(Store).dispatch(new TaskActions.ClearTaskList());
        return true;
      },
    ],
    children: [
      {
        path: ':taskListId',
        component: TaskShellComponent,
        canDeactivate: [() => inject(Store).dispatch(new TaskActions.SetSelectedTasks([]))],
        children: [
          {
            path: 'details/:taskId',
            outlet: 'details',
            loadComponent: () =>
              import('@tasks/task-details/task-details.component').then((c) => c.TaskDetailsComponent),
          },
          {
            path: 'settings',
            loadComponent: () => import('./settings/settings.component').then((comp) => comp.TasksSettingsComponent),
          },
          {
            path: 'list',
            loadComponent: () =>
              import('@tasks/task-view-list/task-view-list.component').then((comp) => comp.TaskViewListComponent),
          },
          {
            path: 'kanban',
            loadComponent: () =>
              import('@tasks/task-view-kanban/task-view-kanban.component').then((comp) => comp.TaskViewKanbanComponent),
          },
          {
            path: 'gantt',
            loadComponent: () =>
              import('@tasks/task-view-gantt/task-view-gantt.component').then((comp) => comp.TaskViewGanttComponent),
          },
          {
            path: 'calendar',
            loadComponent: () =>
              import('@tasks/task-view-calendar/task-view-calendar.component').then(
                (comp) => comp.TaskViewCalendarComponent,
              ),
          },
        ],
      },
    ],
  },
];
